import {DatePicker, Input} from 'antd'
import {getType} from 'apis/model/base'
import EmptyHolder from 'components/EmptyHolder'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import Pure from 'components/Pure'
import {CodiDocumentRowSelect, CodiSelect,} from 'components/RichSlateEditor/utils/useEditorUtils'
import {Formik, FormikConsumer} from 'formik'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useMemo} from 'react'
import {IoCalendarOutline} from 'react-icons/io5'
import {compose, mapProps} from 'recompose'
import {gConfigs} from 'views/AppLocals/configs'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../Shared";
import dayjs from "dayjs";

const LinkDescription = ({item}) => {
    const t = useTranslate()
    const {content, short_index_name, codi_document} = item

    if (_.isEmpty(item)) {
        return null
    }
    return (
        <div className="flex flex-col gap-1 p-2 rounded-lg border border-color-50 shadow-items">
      <span className="text-lg text-primary font-bold">
          {getTitle(codi_document) || getTitle(item)}
          <span className="ml-2 font-medium text-sm text-color-400 italic leading-tight">
              {`(${_.get(codi_document, 'document_no') || _.get(item, 'document_no')})`}
          </span>
      </span>
            {
                renderIf(
                    !!short_index_name,
                    (
                        <span className="space-x-1 italic">
                {short_index_name && (
                    <span className="font-semibold text-sm text-color-000 ml-3">
                      {`${short_index_name} : `}
                  </span>
                )}
                            <span className="text-xs text-color-300 ml-1">
                    {content || _.get(item, 'description')}
                </span>
            </span>
                    )
                )
            }
        </div>
    )
}

const formSchema = {
    link: {
        children: [
            {
                name: 'link',
                component: ({value}) => (
                    <Pure input={[value]}>
                        <LinkDescription item={value}/>
                    </Pure>
                ),
            },
        ],
    },
    description: {
        title: 'note',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    rows: 5,
                    placeholder: 'description',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    eff_date: {
        title: 'eff date',
        children: [
            {
                name: 'eff_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        onChange: (date, dateString) =>
                            onChange(
                                createValue(name, date ? dayjs(new Date(date)) : undefined)
                            ),
                        defaultValue: value ? dayjs(new Date(value)) : undefined,
                        className: 'w-full',
                        placeholder: translate('ex: 20/10/2010'),
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                    }))
                )(DatePicker),
            },
        ],
    },
}

const CodiCreateLink = ({
                            item,
                            selected,
                            owner_id,
                            owner_type,
                            updateToken,
                            onCancel = NullAsDefault,
                            onSubmit = NullAsDefault,
                            defaultValues = {},
                        }) => {
    const t = useTranslate()

    const history = useHistory()

    const initialValues = useMemo(
        () => ({
            ...(item ?? {}),
            ...(defaultValues ?? {}),
        }),
        [item, defaultValues]
    )

    return (
        <React.Fragment>
            <Formik
                onSubmit={(values) => {
                    onSubmit(
                        _.pick(values, [
                            'eff_date',
                            'link_id',
                            'link_type',
                            'description',
                            'related_type',
                        ])
                    )
                }}
                enableReinitialize={true}
                initialValues={initialValues}>
                <div className="flex flex-col gap-2">
                    {_.get(selected, 'index_typecd') && (
                        <div className="flex flex-col gap-1 p-2 rounded-lg background border border-color-50">
              <span className="text-xs text-color-500 font-light italic">
                {t('selected terms')}
              </span>
                            <div className="space-x-1 text-sm">
                                {_.get(selected, 'index_typecd') !== 'content' && (
                                    <span className="font-bold text-color-000">
                    {_.get(selected, 'index_typecd') === 'point' || _.get(selected, 'index_typecd') === 'sentence'
                        ? `${_.get(selected, 'index_name')} : `
                        : `${_.get(selected, 'short_index_name')} : `}
                  </span>
                                )}
                                <span
                                    className={
                                        _.get(selected, 'index_typecd') === 'root'
                                            ? 'text-color-000 font-bold'
                                            : 'text-color-100 italic'
                                    }>
                  {_.get(selected, 'content')}
                </span>
                            </div>
                        </div>
                    )}
                    <div className="flex flex-col mb-1">
            <span className="uppercase text-sm font-semibold text-color-300 tracking-wide mb-1">
              {t('choose a book')}
            </span>
                        <FormikConsumer>
                            {({values, setFieldValue}) => {
                                const codi_document_id = _.get(
                                    values,
                                    'selected_codi_document_id'
                                )
                                return (
                                    <div className="flex flex-col gap-3">
                                        <CodiSelect
                                            onChange={(__, option) => {
                                                setFieldValue('link_id', option?.id)
                                                setFieldValue('link_type', getType(option))
                                                setFieldValue('selected_codi_document_id', option?.id)
                                            }}
                                            placeholder={
                                                <span className="text-xs italic text-color-400">
                          {t('codi document')}
                        </span>
                                            }
                                        />
                                        {codi_document_id && (
                                            <div className="flex flex-col">
                        <span className="uppercase text-sm font-semibold text-color-300 tracking-wide mb-1">
                          {t('select the content to refer to')}
                        </span>
                                                <CodiDocumentRowSelect
                                                    placeholder={
                                                        <span className="text-xs italic text-color-400">
                              {t('ex:type-cd')}
                            </span>
                                                    }
                                                    codi_document_id={codi_document_id}
                                                    onChange={(__, option) => {
                                                        setFieldValue('link_id', option?.id)
                                                        setFieldValue('link_type', getType(option))
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )
                            }}
                        </FormikConsumer>
                    </div>
                    <Pure>
                        <FieldsFactory
                            formSchema={[formSchema.description, formSchema.eff_date]}
                        />
                    </Pure>
                    <FormActionBar submitText="create"/>
                </div>
            </Formik>
        </React.Fragment>
    )
}

export const CodiEditLink = ({
                                 item,
                                 owner_id,
                                 owner_type,
                                 updateToken,
                                 onCancel = NullAsDefault,
                                 onSubmit = NullAsDefault,
                             }) => {
    const history = useHistory()

    const initialValues = useMemo(() => item, [item])

    if (!_.isObject(item)) {
        return <EmptyHolder/>
    }

    return (
        <React.Fragment>
            <Formik
                onSubmit={(values) => {
                    onSubmit(_.pick(values, ['eff_date', 'description']))
                }}
                enableReinitialize={true}
                initialValues={initialValues}>
                <div className="flex flex-col gap-2">
                    <Pure>
                        <FieldsFactory
                            formSchema={[
                                formSchema.link,
                                formSchema.description,
                                formSchema.eff_date,
                            ]}
                        />
                    </Pure>
                    <FormActionBar/>
                </div>
            </Formik>
        </React.Fragment>
    )
}

export default CodiCreateLink
